export default "/_next/static/images/FirstBlockImage-649636ec86f7bde8adf8668cf4f01d55.jpg";